var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .5)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 23.5,
    cy: 23.5,
    r: 23.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#00E784",
    cx: 23.5,
    cy: 23.5,
    r: 19.583
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.689 24.884-10.967 8.16a1.214 1.214 0 0 1-.726.248 1.2 1.2 0 0 1-.665-.205c-.436-.288-.706-.834-.706-1.427V15.34c0-.594.27-1.14.706-1.427.436-.29.969-.272 1.391.043l10.967 8.16c.4.298.644.82.644 1.383 0 .563-.243 1.086-.644 1.384z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/play-button.6ff2884d40f4be4c123a279e9dd522ca.svg";
export { ForwardRef as ReactComponent };